export default __webpack_public_path__ + "static/media/patient-care-logo.83a0e245.png";